import EventManager from 'dd-event-manager';



class BcMatchMedia {
  static TARGETS = [{key: 'pc', attr: 'min-width'}, {key: 'sp', attr: 'max-width'}];



  constructor(breakPoint) {
    new EventManager(this);

    this.breakPoint = breakPoint;
    this.conditions = [];
    this.current    = null;

    this.setup();
  }



  destroy() {
    this.conditions.forEach(condition => {
      condition.stop();
    });
    this.conditions = [];
  }



  setup(breakPoint) {
    if (breakPoint) this.breakPoint = breakPoint;

    if (!this.breakPoint) return;

    this.destroy();

    BcMatchMedia.TARGETS.forEach(TARGET => {
      const key       = TARGET.key,
            attr      = TARGET.attr,
            width     = attr === 'min-width' ? this.breakPoint : this.breakPoint - 1,
            condition = {key: key, condition: `(${attr}: ${width}px)`};

      condition.mql      = window.matchMedia(condition.condition);
      condition.listener = () => { return this.checkCondition(condition) }
      condition.run      = () => { condition.mql.addListener(condition.listener); condition.listener(); }
      condition.stop     = () => { condition.mql.removeListener(condition.listener) }

      this.conditions.push(condition);
    });

    this.conditions.forEach(condition => {
      condition.run();
    });
  }



  ready() {
    return new Promise(resolve => {
      this.hasAndOn('init', resolve);
    });
  }



  setBreakPoint(breakPoint) {
    this.setup(breakPoint);
  }



  checkCondition(condition) {
    if (condition.mql.matches) this.set(condition);
  }



  getConditionByKey(key) {
    return this.conditions.find(condition => condition.key === key);
  }



  set(condition) {
    condition = typeof condition === 'string' ? this.getConditionByKey(condition) : condition;

    const key = condition.key,
          old = this.current;

    this.current = key;

    if (old === null) this.emit('init');

    if (old !== key) this.emit('change', key);
  }
}



export default BcMatchMedia;


// WEBPACK FOOTER //
// ./src/shared/bc-banner/store/modules/bc-match-media.js